import Icon from "assets/icons";

export function getDateFieldIcon(props: {
  clickHandler: () => void;
  showTimeInput?: boolean;
  showTimeSelectOnly?: boolean;
}) {
  if (props.showTimeSelectOnly) {
    return <Icon.ClockIcon size={16} onClick={props.clickHandler} />;
  } else if (props.showTimeInput) {
    return <Icon.Date size={16} onClick={props.clickHandler} />;
  }
  return <Icon.Date size={16} onClick={props.clickHandler} />;
}
